module.exports = __webpack_public_path__ + "img/9788984077744.95ea5ec4.jpg";